export enum LocalStorageKey {
  VISITOR_EMAIL = 'visitorEmail',
  VISITOR_FULL_FIRST_URL = 'visitorFirstFullUrl',
  VISITOR_GCLID = 'visitorGclid',
}

type LocalStorageKeyValues = {
  [LocalStorageKey.VISITOR_EMAIL]: string
  [LocalStorageKey.VISITOR_FULL_FIRST_URL]: string
  [LocalStorageKey.VISITOR_GCLID]: string
}

export interface LocalStorageUtil {
  set: <T extends LocalStorageKey>(
    key: T,
    value: LocalStorageKeyValues[T],
  ) => void
  get: <T extends LocalStorageKey>(key: T) => LocalStorageKeyValues[T]
  remove: (key: LocalStorageKey) => void
}

export const localStorageExtended = {
  set: <T extends LocalStorageKey>(key: T, value: LocalStorageKeyValues[T]) => {
    localStorage.setItem(
      key,
      typeof value === 'string' ? value : JSON.stringify(value),
    )
  },
  get: <T extends LocalStorageKey>(key: T) => {
    const value = localStorage.getItem(key)

    if (!value) {
      return ''
    }

    try {
      const parsedValue = JSON.parse(value)
      return parsedValue as T
    } catch (e) {
      // Stringify a string would throw an error
      return value
    }
  },
  remove: (key: LocalStorageKey) => localStorage.removeItem(key),
}
